import TrackingKeyProvider from '@vp/tracking-key-provider'
import { NRLogger } from '../../modules/logging/nrLogging'

export default class AnalyticsTracking {
  /**
   * Sends the Page event
   * @param {PageData} page
   */
  static sendPageTracking(page) {
    AnalyticsTracking.sendWindowEvent(() => {
      window.tracking.page(page)
    }, 0)
  }

  static sendWindowEvent(event, breaker) {
    if (window && window.tracking && window.tracking.page) {
      event()
    } else if (breaker > 20) {
      NRLogger.error('UBIK Help Center - Tracking', {
        message: 'Tracking not loaded after 20 seconds',
      })
    } else {
      setTimeout(() => this.sendWindowEvent(event, ++breaker), 1000)
    }
  }

  static trackEvent(eventName, subject) {
    AnalyticsTracking.sendEvent(() => {
      window.tracking.track(eventName, {
        subject,
        pageName: 'Help Center',
        pageSection: 'Help Center',
        pageStage: 'Customer Care',
        genTrack: 'Titans Squad',
      })
    }, 0)
  }

  static trackNavigationClicked(eventName, details) {
    AnalyticsTracking.sendEvent(() => {
      const sourcePagePath = window.location.pathname
      const eventDetail = `${sourcePagePath};${details.destinationPagePath};${details.pageZone};${details.ctaValue}`
      window.tracking.track('Navigation Clicked', {
        category: 'Help Center',
        label: `Content:${details.pageZone}`,
        eventDetail,
        navigationDetail: `${details.ctaValue}`,
        pageSection: 'Help Center',
        pageStage: 'Customer Care',
        pageName: 'Help Center',
      })
    }, 0)
  }

  static trackEventWithDetails(eventName, details) {
    AnalyticsTracking.sendEvent(() => {
      window.tracking.track(eventName, details)
    }, 0)
  }

  static sendEvent(event, breaker) {
    if (window && window.tracking && window.tracking.track) {
      event()
    } else if (breaker > 20) {
      NRLogger.error('UBIK Help Center - Tracking', {
        message: 'Tracking not loaded after 20 seconds',
      })
    } else {
      setTimeout(() => this.sendEvent(event, ++breaker), 1000)
    }
  }

  static async getSegmentKey(tenant, locale) {
    if (tenant === 'facemasks') {
      tenant = 'masks'
    }

    const country = locale.substring(locale.indexOf('-') + 1).toUpperCase()
    const key = await TrackingKeyProvider.getWriteKey(tenant, country, 'prod')

    return key
  }

  static getFiscalYear(date) {
    const month = date.getUTCMonth()
    const year = date.getUTCFullYear()

    return 'FY' + ((month > 5 ? year + 1 : year) % 100)
  }
}

/**
 * PageData
 * @typedef PageData
 * @property {string} pageName - Of the format productName:pageSection
 * @property {string} pageSection - Section of the page, which will corresponds to the functional side of it
 * @property {string} pageStage - Stage of the page, which corresponds to what we want the customer do in the website
 */
